import { api } from '../lib/api'

export const feedService = {
  async getFeed() {
    const data = await api.get('/v1/feed')
    return data.posts
  },
  async createPost(payload) {
    const data = await api.post('/v1/posts', payload)
    return data.post
  },
  async likePost(postId) {
    await api.post(`/v1/posts/${postId}/like`, {})
  },
  async unlikePost(postId) {
    await api.delete(`/v1/posts/${postId}/like`)
  }
}
